import { RepositorioBaseComFiltragemDeLeitura } from "@/http"
import { ResultadoApiGET } from "@/types/api"
import { CriarGrupoDeProjetos, EditarGrupoDeProjetos, ListarGruposDeProjetos, ListarGruposDeProjetosSimples, ParametrosGruposDeProjetos } from "./gruposDeProjetos.modelo"

class GruposDeProjetosRepositorio extends RepositorioBaseComFiltragemDeLeitura {
  public listarGruposDeProjetosFrontend = (params?: ParametrosGruposDeProjetos): Promise<ResultadoApiGET<ListarGruposDeProjetos>> =>
    this.instance.get("/api/frontend/grupo-de-projetos", { params })

  public listarGruposDeProjetos = (params?: ParametrosGruposDeProjetos): Promise<ResultadoApiGET<ListarGruposDeProjetosSimples>> =>
    this.instance.get("/api/grupo-de-projetos", { params })

  public criarGrupoDeProjetos = (grupoDeProjetos?: CriarGrupoDeProjetos): Promise<{ id: string }> =>
    this.instance.post("/api/grupo-de-projetos", grupoDeProjetos)

  public editarGrupoDeProjetos = (id?: string, grupoDeProjetos?: EditarGrupoDeProjetos): Promise<{ id: string }> =>
    this.instance.patch(`/api/grupo-de-projetos/${id}`, grupoDeProjetos)

  public deletarGrupoDeProjetos = (id?: string): Promise<{ id: string }> =>
    this.instance.delete(`/api/grupo-de-projetos/${id}`)

}

export default GruposDeProjetosRepositorio
